import { useEffect } from 'react';

export default function usePromptUnloadPage(trigger: boolean): void {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent): string | void => {
      if (!trigger) return;

      const confirmationMessage = 'You have unsaved data. Are you sure want to proceed?';
      e.returnValue = confirmationMessage;
      return confirmationMessage;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [trigger]);
}
